<div class="modal-header border-0 d-flex justify-content-between align-items-center">
  <h5 class="modal-title">{{ filename }}</h5>
  <button type="button" class="btn btn-link p-0 border-0" (click)="activeModal.dismiss()">
    <i class="bi bi-x-lg fs-4"></i>
  </button>
</div>
<div class="modal-body text-center">
  <img [src]="imageUrl" [alt]="filename" class="img-fluid rounded shadow" />
</div>